/** Maps product category tabs to their sourcing pages. Extend when Asset/Commercial go live. */
export const SOURCING_PATH_BY_CATEGORY = {
  BTL: "/mortgages/buy-to-let-mortgage-calculator",
  CBTL: "/mortgages/complex-buy-to-let-mortgage-calculator",
  IF: "/invoice-finance/invoice-finance-sourcing",
};

export const SOURCING_CATEGORY_STORAGE_KEY = "ds_sourcing_category";

const VALID_CATEGORIES = new Set(Object.keys(SOURCING_PATH_BY_CATEGORY));

export function normalizeSourcingCategory(value) {
  const cat = String(value || "").trim().toUpperCase();
  if (VALID_CATEGORIES.has(cat)) return cat;
  if (cat.includes("INVOICE")) return "IF";
  if (cat === "CBTL" || cat.includes("COMPLEX")) return "CBTL";
  if (cat.includes("BUY-TO-LET") || cat.includes("BUY TO LET") || cat === "BTL") return "BTL";
  if (cat.includes("ASSET")) return "ASSET";
  if (cat.includes("COMMERCIAL")) return "COMMERCIAL";
  return null;
}

export function sourcingCategoryFromPath(pathname) {
  const p = String(pathname || "").toLowerCase();
  if (p.includes("invoice-finance") || p.includes("/sourcing/invoice")) return "IF";
  if (
    p.includes("complex-buy-to-let") ||
    p.includes("complex-btl") ||
    p.includes("complex_btl") ||
    p.includes("/sourcing/complex")
  ) return "CBTL";
  if (
    p.includes("buy-to-let") ||
    p.includes("/sourcing/btl") ||
    p === "/source" ||
    p.startsWith("/source?")
  ) return "BTL";
  return null;
}

export function rememberSourcingCategory(category) {
  const cat = normalizeSourcingCategory(category);
  if (!cat || !VALID_CATEGORIES.has(cat)) return;
  try {
    sessionStorage.setItem(SOURCING_CATEGORY_STORAGE_KEY, cat);
  } catch {
    /* ignore */
  }
}

export function readRememberedSourcingCategory() {
  try {
    return normalizeSourcingCategory(sessionStorage.getItem(SOURCING_CATEGORY_STORAGE_KEY));
  } catch {
    return null;
  }
}

export function sourcingPathForCategory(category) {
  const cat = normalizeSourcingCategory(category);
  return SOURCING_PATH_BY_CATEGORY[cat] || SOURCING_PATH_BY_CATEGORY.BTL;
}

/** Shortlist tabs: Complex BTL products sit under BTL. */
export function shortlistTabForCategory(category) {
  const cat = normalizeSourcingCategory(category) || String(category || "").trim().toUpperCase();
  if (cat === "CBTL") return "BTL";
  return VALID_CATEGORIES.has(cat) ? cat : "BTL";
}

export function shortlistPathForCategory(category) {
  const cat = normalizeSourcingCategory(category) || readRememberedSourcingCategory() || "BTL";
  const resolved = shortlistTabForCategory(cat);
  return `/borrower/shortlisted?category=${encodeURIComponent(resolved)}`;
}

export function resolveShortlistCategory(location) {
  const params = new URLSearchParams(location?.search || "");
  const fromQuery = normalizeSourcingCategory(params.get("category") || params.get("tab"));
  if (fromQuery && VALID_CATEGORIES.has(fromQuery)) return shortlistTabForCategory(fromQuery);

  const fromState = normalizeSourcingCategory(
    location?.state?.productCategory || location?.state?.category || location?.state?.productType
  );
  if (fromState && VALID_CATEGORIES.has(fromState)) return shortlistTabForCategory(fromState);

  const remembered = readRememberedSourcingCategory();
  if (remembered && VALID_CATEGORIES.has(remembered)) return shortlistTabForCategory(remembered);

  return "BTL";
}
